import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export const PrivateRoute = ({
  children,
  rolesPermitidos = [],
  modulo = null,
  modulos = [],
  soloAdmin = false,
}) => {
  const { auth, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!auth || !auth.id) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (soloAdmin && auth.rol !== "admin") {
    return (
      <div className="acceso-denegado">
        <h2>Acceso denegado</h2>
        <p>No tienes permisos para ver esta sección.</p>
      </div>
    );
  }

  if (auth.rol === "admin") {
    return children;
  }

  if (rolesPermitidos.length > 0 && !rolesPermitidos.includes(auth.rol)) {
    return (
      <div className="acceso-denegado">
        <h2>Acceso denegado</h2>
        <p>No tienes permisos para ver esta sección.</p>
      </div>
    );
  }

  const modulosRequeridos = [
    ...(modulo ? [modulo] : []),
    ...(Array.isArray(modulos) ? modulos : []),
  ];

  if (modulosRequeridos.length > 0) {
    const tieneAlgunModulo = modulosRequeridos.some(
      (m) => auth.modulos?.[m] === true
    );

    if (!tieneAlgunModulo) {
      return (
        <div className="acceso-denegado">
          <h2>Acceso denegado</h2>
          <p>No tienes permisos para ver esta sección.</p>
        </div>
      );
    }
  }

  return children;
};